// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1Xnpg","validationTips":"StatementDescriptor_validationTips__QIbBb"};